const cloneObject = object => JSON.parse(JSON.stringify(object));

export default cloneObject;
